import type { State } from '../configureStore'
import { FailedObject as ActionTypes } from '../actionTypes'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import uuidv4 from 'uuid/v4'
import * as intentproto from '@src/endpoints/services/intentMgr.service'
import { defaultHandleStatus } from '@src/endpoints/helpers'
import * as AlertApi from '@src/endpoints/openapis/saas-cam-alerts/api'
import { DismissAlertRequest } from '@src/endpoints/openapis/saas-cam-alerts/api'

// Action Creators
export type ActionTypes = dismissPendingAction | remediatePendingAction

const dismissPending = (pending = true) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.DISMISS_PENDING, {
    pending
  })

type dismissPendingAction = ReturnType<typeof dismissPending>

const remediatePending = (pending = true) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.REMEDIATE_PENDING, {
    pending
  })
type remediatePendingAction = ReturnType<typeof remediatePending>

export function onDismiss(
  {
    items,
    monitorId
  }: { items: intentproto.AlertActionReq[]; monitorId: string },
  callback?: () => void
) {
  return (dispatch: any, getStore: () => State) => {
    const params: intentproto.MultiAlertActionReq = {
      req_hdr: {
        tid: uuidv4()
      },
      items,
      monitor_id: monitorId
    }
    dispatch(dismissPending())
    intentproto.IntentMgr.DismissAlert({ params })
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            dispatch(dismissPending(false))
            if (callback) callback()
          },
          true
        )
      )
      .then(response => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
      .catch((res: Response) => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
  }
}

export function onDismissNew(
  params: DismissAlertRequest,
  callback?: () => void
) {
  return (dispatch: any, getStore: () => State) => {
    dispatch(dismissPending())
    AlertApi.dismissAlert(params)
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            dispatch(dismissPending(false))
          },
          true
        )
      )
      .then(response => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
      .catch((res: Response) => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
  }
}

export function onKeep(
  {
    items,
    monitorId
  }: { items: intentproto.AlertActionReq[]; monitorId: string },
  callback?: () => void
) {
  return (dispatch: any, getStore: () => State) => {
    const params: intentproto.MultiAlertActionReq = {
      req_hdr: {
        tid: uuidv4()
      },
      items,
      monitor_id: monitorId
    }
    dispatch(dismissPending())
    intentproto.IntentMgr.KeepAlert({ params })
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            dispatch(dismissPending(false))
            if (callback) callback()
          },
          true
        )
      )
      .then(response => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
      .catch((res: Response) => {
        dispatch(dismissPending(false))
        if (callback) callback()
      })
  }
}
